export default __webpack_public_path__ + "static/media/product-3.eb97c860.jpg";